import { all, fork, takeLatest, takeLeading } from 'redux-saga/effects';
import { sliceName } from '../redux/tablesSlice';
import * as Sagas from './saga';

function* watchFetchTableByIdData() {
    yield takeLatest(
        `${sliceName}/fetchTableDataById`,
        Sagas.fetchTableDataById
    );
}

function* watchHandlePathChanged() {
    yield takeLatest(`${sliceName}/handlePathChanged`, Sagas.handlePathChanged);
}

function* watchFetchTableNextPage() {
    yield takeLeading(
        `${sliceName}/fetchTableNextPage`,
        Sagas.fetchTableNextPageSaga
    );
}

export function* tablesSagas() {
    yield all([
        fork(watchFetchTableByIdData),
        fork(watchHandlePathChanged),
        fork(watchFetchTableNextPage),
    ]);
}
